export default __webpack_public_path__ + "static/media/gallery-wip-emitter_00.73ae2788.jpg";